export const getErrorMessage = (error) => {
  if (!error?.response?.data) {
    return "Something went wrong. Please try again.";
  }

  const data = error.response.data;

  // { message: "..." }
  if (typeof data.message === "string") {
    return data.message;
  }

  // { error: "..." }
  if (typeof data.error === "string") {
    return data.error;
  }

  // { error: { message: "...", errorType: "..." } }
  if (data.error?.message) {
    return data.error.message;
  }

  // { message: { message: "..." } }
  if (data.message?.message) {
    return data.message.message;
  }

  return "Something went wrong. Please try again.";
};
